// REFACTOR LATTER

export const getMainProductImage = (imgArray) => {
  try {
    if (imgArray && imgArray.length > 0) {
      const mainImage = imgArray.find(
        (imgs) => imgs.type === 'main' || !!imgs.type,
      )
      if (mainImage.urls && mainImage.urls.length > 0) {
        const selectedImage = mainImage.urls.find(
          (img) => img.type === 'medium' || !!img.type,
        )
        return selectedImage.url
      }
    }
  } catch {
    // TODO
  }
  return ''
}
